import {KTIcon} from '../../../../../_handld/helpers'
import {useListView} from '../core/ListViewProvider'

const PasswordEditModalHeader = () => {
  const {setItemIdForUpdatePassword} = useListView()

  return (
    <div className='modal-header'>
      {/* begin::Modal title */}
      <h2 className='fw-bolder'>Reset Password</h2>
      {/* end::Modal title */}

      {/* begin::Close */}
      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        data-kt-users-modal-action='close'
        onClick={() => setItemIdForUpdatePassword?.(undefined)}
        style={{cursor: 'pointer'}}
      >
        <KTIcon iconName='cross' className='fs-1' />
      </div>
      {/* end::Close */}
    </div>
  )
}

export {PasswordEditModalHeader}
